import React from 'react';

export const BackIcon = ({ fill = '#E1F4D3', stroke = '#1C452B', width, height, className }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M30 55C43.807 55 55 43.807 55 30C55 16.1929 43.807 5 30 5C16.1929 5 5 16.1929 5 30C5 43.807 16.1929 55 30 55Z" fill={fill} stroke={stroke} strokeWidth="3.75" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M33.1515 38.8242L24.3516 29.9992L33.1515 21.1743" stroke={stroke} strokeWidth="3.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
